import Icon from '../components/Icon.vue'

Icon.register({"ruler-combined":{"width":512,"height":512,"paths":[{"d":"M160 288H104C99.6 288 96 284.4 96 280V264C96 259.6 99.6 256 104 256H160V192H104C99.6 192 96 188.4 96 184V168C96 163.6 99.6 160 104 160H160V96H104C99.6 96 96 92.4 96 88V72C96 67.6 99.6 64 104 64H160V32C160 14.3 145.7 0 128 0H32C14.3 0 0 14.3 0 32V480C0 482.8 0.9 485.2 1.6 487.8L160 329.4V288zM480 352H448V408C448 412.4 444.4 416 440 416H424C419.6 416 416 412.4 416 408V352H352V408C352 412.4 348.4 416 344 416H328C323.6 416 320 412.4 320 408V352H256V408C256 412.4 252.4 416 248 416H232C227.6 416 224 412.4 224 408V352H182.6L24.2 510.4C26.8 511.1 29.2 512 32 512H480C497.7 512 512 497.7 512 480V384C512 366.3 497.7 352 480 352z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/ruler-combined.js
// module id = null
// module chunks = 